// Semantic-version utilities for the web force-update flow.
//
// Versions are dotted numeric strings ("1.4.2"). Pre-release / build metadata
// suffixes ("1.4.2-rc1", "1.4.2+build5") are tolerated: anything after the
// first non-numeric character on a segment is dropped before comparison.

function parseSegments(v) {
  if (typeof v !== 'string') return null;
  let trimmed = v.trim();
  if (!trimmed) return null;
  // Tolerate an optional leading "v" prefix ("v1.4.2"). Anything else that
  // doesn't start with a digit is rejected so we never lock users out on a
  // typo'd or unparseable version string.
  if (trimmed[0] === 'v' || trimmed[0] === 'V') trimmed = trimmed.slice(1);
  if (!/^\d/.test(trimmed)) return null;
  return trimmed.split('.').map(seg => {
    const match = String(seg).match(/^\d+/);
    return match ? Number(match[0]) : 0;
  });
}

// Returns -1 if a<b, 0 if equal, 1 if a>b. Returns null on bad input.
function compareVersions(a, b) {
  const A = parseSegments(a);
  const B = parseSegments(b);
  if (!A || !B) return null;
  const len = Math.max(A.length, B.length);
  for (let i = 0; i < len; i++) {
    const ai = A[i] || 0;
    const bi = B[i] || 0;
    if (ai < bi) return -1;
    if (ai > bi) return 1;
  }
  return 0;
}

// True iff the local version is older than the required minimum. Bad / missing
// inputs return false so we never lock users out on a parsing error.
function isUpdateRequired(localVersion, minVersion) {
  if (!localVersion || !minVersion) return false;
  const cmp = compareVersions(localVersion, minVersion);
  if (cmp === null) return false;
  return cmp < 0;
}

module.exports = {
  parseSegments,
  compareVersions,
  isUpdateRequired
};
